import { usePopup } from "../../common/contexts/PopupContext";
import useOrganization from "../../common/hooks/pages/useOrganization";
import ListUsers from "../components/ListUsers";
import { useMutation, useQuery } from "react-query";
import ApiValidate from "../../common/components/ApiValidate";
import useInvitations from "../../common/hooks/pages/useInvitations";
import { useState } from "react";

function UsersContainer() {
  const [openInviteForm, setOpenInviteForm] = useState(false);
  const [editMemberPermissions, setEditMemberPermissions] = useState();

  const { getOrganizationMembers } = useOrganization();

  const { toast } = usePopup();

  const { data, isLoading, isError, refetch } = useQuery({
    retry: false,
    queryKey: "organizationMembers",
    queryFn: getOrganizationMembers,
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while getting memebers!";

      toast(message, "error");
    },
  });

  const { sendInvitation, resendInvitation } = useInvitations();

  const { mutate: sendInvitationMutate, isLoading: isSendingInvitation } =
    useMutation({
      mutationFn: sendInvitation,
      onSuccess: (res) => {
        const { message } = res?.data || {};
        refetch();
        setOpenInviteForm(false);
        toast(message, "success");
      },
      onError: (error) => {
        const message =
          error?.response?.data?.message ||
          "Something went wrong while sending invitations!";
        toast(message, "error");
      },
    });

  const { mutate: reSendInvitationMutate, isLoading: isReSendingInvitation } =
    useMutation({
      mutationFn: resendInvitation,
      onSuccess: (res) => {
        const { message } = res?.data || {};
        refetch();
        setOpenInviteForm(false);
        toast(message, "success");
      },
      onError: (error) => {
        const message =
          error?.response?.data?.message ||
          "Something went wrong while sending invitations!";
        toast(message, "error");
      },
    });

  return (
    <ApiValidate isLoading={isLoading} isError={isError}>
      <ListUsers
        usersData={data?.data || {}}
        sendInvitationProps={{
          sendInvitationMutate,
          isSendingInvitation,
        }}
        reSendInvitationProps={{
          reSendInvitationMutate,
          isReSendingInvitation,
        }}
        openInviteForm={openInviteForm}
        setOpenInviteForm={setOpenInviteForm}
        editMemberPermissionsProps={{
          editMemberPermissions,
          setEditMemberPermissions,
        }}
      />
    </ApiValidate>
  );
}

export default UsersContainer;
